import {useAuth} from "../../store/AuthProvider";
import {Navigate, Outlet} from "react-router-dom";
import Header from "../../components/admin/layouts/Header";
import {Container} from "@mui/material";
import CONFIG from "../../config/_config";
import ModalProvider from "../../store/admin/ModalProvider";
import ModalManager from "../../components/admin/modals/ModalManager";
import NotificationProvider from "../../store/admin/NotificationProvider";

const AdminRootLayout = () => {
    const user = useAuth();

    if (!user.token) return <Navigate to='/auth' />;

    return <>
        <ModalProvider>
            <NotificationProvider>
                <ModalManager />
                <Header />
                <Container maxWidth='false' sx={{minHeight: '100dvh', backgroundColor: '#ffffff', ml: {xs: 0, md: CONFIG.drawerWidth}, mb: {xs: 10, md: 0}, py: 4, px: {xs: 2, md: 6}, width: {xs: '100vw', md: `calc(100vw - ${CONFIG.drawerWidth})`} }}>
                    <Outlet />
                </Container>
            </NotificationProvider>
        </ModalProvider>
    </>
}

export default AdminRootLayout;